module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDIyIDIyIj4NCiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0Y3NDU0NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiPg0KICAgICAgICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxMCIvPg0KICAgICAgICA8cGF0aCBkPSJNMTMgN2wtNiA2TTcgN2w2IDYiLz4NCiAgICA8L2c+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x-circle.svg
// module id = z6Az
// module chunks = 1